var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearFilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 0H0.410156C0.183641 0 0 0.183641 0 0.410156V1.91406H14V0.410156C14 0.183641 13.8164 0 13.5898 0Z",
    fill: "#FF8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.96484C0 4.09552 0.0622891 4.2184 0.167672 4.29565L5.22266 8.00086V12.4957C5.22266 12.6634 5.32476 12.8142 5.48048 12.8765L8.21486 13.9702C8.48427 14.078 8.77734 13.8796 8.77734 13.5894V11.4795C7.78632 10.787 7.13672 9.63791 7.13672 8.33984C7.13672 6.22902 8.85402 4.51172 10.9648 4.51172C11.6519 4.51172 12.2971 4.69377 12.8551 5.01195L13.8323 4.29565C13.9377 4.21838 14 4.09552 14 3.96484V2.73438H0V3.96484Z",
    fill: "#FF8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9648 5.33203C9.30368 5.33203 7.95703 6.67868 7.95703 8.33984C7.95703 10.001 9.30368 11.3477 10.9648 11.3477C12.626 11.3477 13.9727 10.001 13.9727 8.33984C13.9727 6.67868 12.626 5.33203 10.9648 5.33203ZM12.2216 9.01657C12.3818 9.17675 12.3818 9.43644 12.2216 9.59662C12.0614 9.7568 11.8018 9.7568 11.6416 9.59662L10.9648 8.91989L10.2881 9.59662C10.1279 9.7568 9.86825 9.7568 9.70807 9.59662C9.54789 9.43644 9.54789 9.17675 9.70807 9.01657L10.3848 8.33984L9.70807 7.66311C9.54789 7.50293 9.54789 7.24325 9.70807 7.08307C9.86825 6.92289 10.1279 6.92289 10.2881 7.08307L10.9648 7.7598L11.6416 7.08307C11.8018 6.92289 12.0614 6.92289 12.2216 7.08307C12.3818 7.24325 12.3818 7.50293 12.2216 7.66311L11.5449 8.33984L12.2216 9.01657Z",
    fill: "#FF8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilt);
export default __webpack_public_path__ + "static/media/clearFilt.ac24883a7d39f1821e11714e7d75c288.svg";
export { ForwardRef as ReactComponent };